module.exports = __webpack_public_path__ + "assets/c9a16c6b9de078611f1c91e7f62b0e8b.mp3";